module.exports = __webpack_public_path__ + "static/media/search-icon.558b5ec4.svg";